import React, { useState } from "react";
import { Card, Form, Row, Col, Image, Button } from "react-bootstrap";
import { useUploadFile } from "../../../../../../api/fileUpload/fileUpload.hooks";

const ExploreEventsSection = ({ data, onUpdate }) => {
  const [isOpen, setIsOpen] = useState(true);
  const { upload, isLoading: isUploading } = useUploadFile();

  const handleChange = (field, value) => {
    onUpdate({ ...data, [field]: value });
  };

  const handleSectionChange = (index, field, value) => {
    const updatedSections = [...data.sections];
    updatedSections[index] = { ...updatedSections[index], [field]: value };
    handleChange("sections", updatedSections);
  };

  const handleFileUpload = async (index, file) => {
    try {
      const res = await upload(file);
      if (res?.url) {
        handleSectionChange(index, "image", res.url);
      }
    } catch (err) {
      console.error("File upload failed:", err);
    }
  };

  const addSection = () => {
    const newSection = { title: "", image: "", upcomingEventsCount: "" };
    handleChange("sections", [...data.sections, newSection]);
  };

  const removeSection = (index) => {
    const updatedSections = data.sections.filter((_, i) => i !== index);
    handleChange("sections", updatedSections);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Explore Events Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data.isVisible}
          onChange={(e) => handleChange('isVisible', e.target.checked)}
          className="mb-0"
        />
      </Card.Header>
      {data.isVisible && (
        <Card.Body>
          <Row>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Heading</Form.Label>
                <Form.Control
                  type="text"
                  value={data.heading}
                  onChange={(e) => handleChange("heading", e.target.value)}
                  placeholder="Enter section heading"
                />
              </Form.Group>
            </Col>
            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={data.description}
                  onChange={(e) => handleChange("description", e.target.value)}
                  placeholder="Enter section description"
                />
              </Form.Group>
            </Col>
          </Row>

          <h6 className="mt-4 mb-3">Event Sections</h6>
          {data.sections.map((section, index) => (
            <div key={index} className="mb-4 p-3 border rounded">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h6>Section {index + 1}</h6>
                {data.sections.length > 1 && (
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeSection(index)}
                  >
                    Remove
                  </Button>
                )}
              </div>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Title</Form.Label>
                    <Form.Control
                      type="text"
                      value={section.title}
                      onChange={(e) => handleSectionChange(index, "title", e.target.value)}
                      placeholder="Enter section title"
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Upcoming Events Count</Form.Label>
                    <Form.Control
                      type="number"
                      value={section.upcomingEventsCount}
                      onChange={(e) => handleSectionChange(index, "upcomingEventsCount", e.target.value)}
                      placeholder="Enter events count"
                    />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group className="mb-3">
                    <Form.Label>Image</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) =>
                        e.target.files?.[0] && handleFileUpload(index, e.target.files[0])
                      }
                    />
                    {isUploading && (
                      <div className="text-muted small mt-1">
                        Uploading...
                      </div>
                    )}
                    {section.image && (
                      <div className="mt-2">
                        <Image
                          src={section.image}
                          alt="Preview"
                          thumbnail
                          style={{ maxWidth: "200px" }}
                        />
                      </div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
            </div>
          ))}
          <Button variant="outline-primary" onClick={addSection}>
            Add Event Section
          </Button>
        </Card.Body>
      )}
    </Card>
  );
};

export default ExploreEventsSection;
